import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "../../../common/consts/colors";

const CalendarsIcon = ({ color = "black" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66667 1.66669C7.1269 1.66669 7.5 2.03978 7.5 2.50002V3.33335H12.5V2.50002C12.5 2.03978 12.8731 1.66669 13.3333 1.66669C13.7936 1.66669 14.1667 2.03978 14.1667 2.50002V3.33335H15C16.3807 3.33335 17.5 4.45264 17.5 5.83335V6.66669H2.5V5.83335C2.5 4.45264 3.61929 3.33335 5 3.33335H5.83333V2.50002C5.83333 2.03978 6.20643 1.66669 6.66667 1.66669Z"
        fill={COLORS[color]}
      />
      <path
        d="M2.5 8.33335V15.8334C2.5 17.2141 3.61929 18.3334 5 18.3334H15C16.3807 18.3334 17.5 17.2141 17.5 15.8334V8.33335H2.5Z"
        fill={COLORS[color]}
      />
    </svg>
  );
};

export default CalendarsIcon;
